<template>
  <div class="m-t-15">
    <div class="card">
      <div class="section">
        <base-section-title class="section-title" title="采购申请" />

        <div class="section-content">
          <el-form label-width="120px" label-suffix="：" class="detail-form">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="项目编号">
                  <span>{{ formData.requirementCode || '-' }}</span>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="申请人">
                  {{ formData.oaApplierName }}
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="申请人电话">
                  {{ formData.oaApplierPhone }}
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="申请部门">
                  {{ formData.oaApplierDeptName }}
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="建议完成时间">
                  {{ formData.expectCompleteTime }}
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="建议采购方式">
                  {{ expectPurchaseMethod }}
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="采购类别">
                  {{ formData.categoryName }}
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="申请单经办人">
                  {{ formData.executorName }}
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="备注说明">
                  {{ formData.requirementRemark }}
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="section">
        <base-section-title title="品目信息" class="section-title" />

        <apply-material-table ref="applyMaterialTable" :table-data="formData.itemList" :can-edit="false" />
      </div>
    </div>
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import ApplyMaterialTable from '@/components/purchase-demand/material/ApplyMaterialTable'

// 数据字典
import { purchasePlanMethodDict } from '@/dictionary/purchase-demand'
// 后端接口api
import { getPurchaseApplyDetailApi } from '@/api/purchase-demand/apply'

export default {
  name: 'PurchaseApplyInfo',

  components: {
    BaseSectionTitle,
    ApplyMaterialTable
  },

  props: {
    requestQuery: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      formData: {}
    }
  },

  computed: {
    expectPurchaseMethod() {
      return (
        purchasePlanMethodDict.translate(this.formData.purchaseMethod)?.label ||
        '-'
      )
    }
  },

  watch: {
    'requestQuery.id': {
      handler(newVal) {
        this.getPurchaseApplyDetail()
      },

      immediate: true
    }
  },

  methods: {
    // 获取申请单详情
    getPurchaseApplyDetail() {
      if (!this.requestQuery.id) return

      getPurchaseApplyDetailApi(this.requestQuery.id)
        .then(res => {
          this.formData = res.data
        })
        .catch(err => {
          this.$message.error(err?.message || '获取申请单详情失败')
        })
    }
  }
}
</script>
